module.exports = __webpack_public_path__ + "img/1407404772.c60212b6.jpg";